import React from 'react'
import adi from './Images/Adi.jpg'

export default function About() {
  return (
    <div >
        <div id="About" className='aboutMain'>
          <div  className='aboutTitle'>  
            <br/>
                About 
            </div>  
            <div className='aboutBg'>
                <div className='aboutGrid'>
                    <table>
                        <tr>
                        <td>
                        <div className="aboutImg">
                        <img src={adi} height={400} width={370}/>
                        </div>
                        </td>
                        <td>
                        <div className='aboutContent'>
                        I am Adityaraj Patil currently pursuing a BTech degree in CS at PCCOE-Pimpri Chinchwad College Of Engineering, Pune. A Frontend Developer, Java Developer and an Open Source Ethuasiast.
                        </div>
                        </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
  )
}
